import React from 'react';
export function Footer() {
  return <footer className="bg-dark text-crema py-12 px-6 lg:px-12 mt-12" data-id="element-77" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 items-center md:items-start text-center md:text-left" data-id="element-78" data-mp="3ggarzyv0aj71">
        <div className="space-y-4" data-id="element-79" data-mp="32pp4txyirn3c">
          <h3 className="text-2xl font-serif text-white" data-id="element-80" data-mp="36p6d0z5byyc7">
            Tu espacio para sanar
          </h3>
          <p className="text-gray-400 text-sm max-w-xs mx-auto md:mx-0" data-id="element-81" data-mp="3ueik9th3kwbv">
            Acompañamiento psicológico profesional, empático y confidencial para
            tu bienestar emocional.
          </p>
        </div>

        <div className="space-y-4" data-id="element-82" data-mp="3ldalzbekzvhs">
          <h4 className="text-lg font-medium text-white" data-id="element-83" data-mp="3le2fmgombj5f">Contacto</h4>
          <ul className="text-gray-400 text-sm space-y-2" data-id="element-84" data-mp="3qcdp2qb03rn4">
            <li data-id="element-85" data-mp="29zgl41oc4umn">Atención presencial y online</li>
            <li data-id="element-86" data-mp="29xlymixf0ugg">Consultorio en Neuquén Capital</li>
            <li data-id="element-87" data-mp="2ey09e8qeiii6">Lunes a Viernes de 9:00 a 19:00hs</li>
          </ul>
        </div>

        <div className="space-y-4 md:text-right" data-id="element-88" data-mp="2evxaez79tf1b">
          <h4 className="text-lg font-medium text-white" data-id="element-89" data-mp="3lalg1f31y5ty">Reserva tu turno</h4>
          <p className="text-gray-400 text-sm mb-4" data-id="element-90" data-mp="3gaz1n2bhmjjk">
            Escríbeme por WhatsApp para coordinar nuestra primera sesión.
          </p>
          <a href="https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno" target="_blank" rel="noopener noreferrer" className="inline-block border border-terracota text-terracota hover:bg-terracota hover:text-white px-6 py-2 rounded-full transition-colors duration-300 text-sm" data-id="element-91" data-mp="3v9axx7uy7qa7">
            Enviar Mensaje
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-gray-700 text-center text-gray-500 text-sm" data-id="element-92" data-mp="cu0hytbykx5m">
        <p data-id="element-93" data-mp="qsqdi4j4qorv">
          &copy; {new Date().getFullYear()} Lic. María Alejandra Ruiz. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}